export default "__VITE_ASSET__DuQWC24F__"